import { gql } from "@apollo/client";
import { Reservation as reservation } from "../fragments";
import SEARCH_SYNOPSIS_TERMS from "../fragments/SearchSynopsisTerms";

const FETCH_RESERVATION = props => gql`
  query FetchReservation($id: Int) {
    reservation(id: $id) {
      ${reservation(props)}
    }
  }
`;

const FETCH_RESERVATIONS_V2 = props => gql`
  query FetchReservationV2($input: AdvReservationFilterInput!) {
    reservationsV2(input: $input) {
      count
      edges {
        ${reservation(props)}
      }
      sqlQuery
    }
  }
`;

const RESERVATION_LIST_FIELDS = `
  count
  edges {
    id
    categoryId
    type {
      description
    }
    date
    dateDue
    reservationUser {
      name
    }
    createdBy {
      name
    }
    reservationInstanceCount
  }
  sqlQuery
`;

const FETCH_RESERVATIONS_LIST = props => gql`
  query FetchReservationList($input: AdvReservationFilterInput!) {
    reservationsV2(input: $input) {
      ${RESERVATION_LIST_FIELDS}
    }
  }
`;

// The results page also shows the search as removable tags.
const FETCH_RESERVATIONS_SEARCH_RESULTS = gql`
  query FetchReservationsSearchResults($input: AdvReservationFilterInput!) {
    reservationsV2(input: $input) {
      ${RESERVATION_LIST_FIELDS}
      ${SEARCH_SYNOPSIS_TERMS}
    }
  }
`;

export {
  FETCH_RESERVATION,
  FETCH_RESERVATIONS_V2,
  FETCH_RESERVATIONS_LIST,
  FETCH_RESERVATIONS_SEARCH_RESULTS,
};
